export class ModelSection {

    constructor(data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.project = data.project ?? null;
        this.geoSection = data.geoSection ?? null;
        this.notes = data.notes ?? null;
        this.intervals = data.intervals ?? [];
        this.boundaries = data.boundaries ?? [];
        this.loads = data.loads ?? [];
        this.objects = data.objects ?? [];

    }

}
